import { ITranslations } from 'types/common';
import { DiscountsTransFields } from './types';
import en from 'translations/en/discounts.json';
import pl from 'translations/pl/discounts.json';
import sl from 'translations/sl/discounts.json';

export const discountsTranslations: ITranslations<DiscountsTransFields> = {
  name: 'discounts',
  en,
  pl,
  sl,
};
